import React, { lazy, useEffect } from "react";
import { useUser } from "reactfire";
import { useUserProfile } from "./components/hooks/firestore/useUserProfile";
import { auth } from "./services/firebase";
import { signOut } from "firebase/auth";

const LoginRegister = lazy(() => import("./pages/other/LoginRegister"));

// React Router v6 compatible PrivateRoute.
// Usage in routes: <Route path={...} element={<PrivateRoute element={<YourComponent />} />} />
const PrivateRoute = ({ element, detailPage = false }) => {
  const { data: authUser, status: authStatus } = useUser();
  const { data: profile, isLoading: profileLoading } = useUserProfile();
  const isAuthenticated =
    authStatus === "success" && !!authUser && !!authUser.uid;
  const authorizationLoaded = !profileLoading;
  const isAuthorized =
    authorizationLoaded && profile?.authorization?.isAuthorized;

  useEffect(() => {
    if (
      !!profile &&
      profile?.authorization?.isReviewed &&
      !profile?.authorization?.isAuthorized
    )
      signOut(auth);
  }, [profile]);

  // In v6 we simply return the element to render.
  const Allowed = authorizationLoaded ? (
    isAuthenticated && isAuthorized ? (
      element
    ) : (
      <LoginRegister />
    )
  ) : isAuthenticated ? (
    element
  ) : (
    <LoginRegister />
  );

  return Allowed;
};

export default PrivateRoute;
